import { getUserColor } from "@/lib/canvas-avatar/generator";
import { cn } from "@/lib/utils";

export interface UserAvatarProps {
  userName: string;
  userId: string;
  className?: string;
}

export function UserAvatar({
  userName,
  userId,
  className,
}: UserAvatarProps): React.ReactNode {
  const color = getUserColor(userId, userName);

  const initials =
    (userName || "U")
      .trim()
      .split(" ")
      .filter((n) => n.length > 0)
      .map((n) => n[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() || "U";

  return (
    <div
      className={cn(
        "size-6 rounded-md",
        "flex items-center text-center justify-center",
        "font-semibold text-[10px] text-white",
        "flex-shrink-0",
        className
      )}
      style={{ backgroundColor: color }}
    >
      {initials}
    </div>
  );
}
